// extracted by mini-css-extract-plugin
export default {"blinking":"style_blinking__UwxVR","fadein":"style_fadein__WOK7O"};